import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [user, setUser] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      fetch('/api/auth/me', {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(r => r.json())
        .then(data => {
          if (data.email) setUser(data);
        })
        .catch(() => localStorage.removeItem('token'));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    navigate('/');
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-2xl font-bold text-blue-700">Tax</span>
            <span className="text-2xl font-bold text-gray-800">Thinker</span>
          </Link>

          <div className="hidden md:flex items-center space-x-6">
            <Link to="/tools/capital-gain"
              className="text-gray-600 hover:text-blue-700 font-medium transition">
              Capital Gain
            </Link>
            <Link to="/tools/tds-calculator"
              className="text-gray-600 hover:text-blue-700 font-medium transition">
              TDS Calculator
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            {user ? (
              <div className="flex items-center space-x-3">
                <span className="text-gray-700 font-medium">{user.name}</span>
                <span className="bg-blue-100 text-blue-700 text-xs px-2 py-1 rounded-full font-semibold uppercase">
                  {user.plan}
                </span>
                <button onClick={handleLogout}
                  className="text-gray-500 hover:text-red-600 text-sm transition">
                  Logout
                </button>
              </div>
            ) : (
              <a href="/api/auth/google"
                className="bg-blue-700 text-white px-4 py-2 rounded-lg hover:bg-blue-800 transition font-medium text-sm">
                Login with Google
              </a>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
